/* yungi · Black Friday : chrono de la barre et de l'encadré fiche (cycle de N jours depuis une date de départ, heure de Paris) */
(() => {
  const box = document.querySelector('[data-bf-box]');
  const bar = document.querySelector('[data-bf-cd]');
  if (!box && !bar) return;
  const src = box || document.body;
  const ancre = Date.parse((box && box.dataset.ancre) || '2026-11-05T00:00:00+01:00');
  const cyc = Math.max(1, parseFloat((box && box.dataset.cycle) || '5')) * 864e5;
  const end = () => { const n = Date.now(); if (isNaN(ancre) || n < ancre) return (isNaN(ancre) ? n : ancre) + cyc; return ancre + Math.ceil((n - ancre + 1) / cyc) * cyc; };
  const p = v => String(v).padStart(2, '0');
  const tick = () => {
    const s = Math.max(0, Math.floor((end() - Date.now()) / 1000));
    const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    const t = box && box.querySelector('[data-bf-left]'); if (t) t.textContent = `${d}j ${p(h)}:${p(m)}:${p(x)}`;
    if (bar) { const q = k => bar.querySelector(k); if (q('[data-d]')) { q('[data-d]').textContent = p(d); q('[data-h]').textContent = p(h); q('[data-m]').textContent = p(m); q('[data-s]').textContent = p(x); } }
  };
  tick(); setInterval(tick, 1000);
})();
